import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-expiring-token',
    templateUrl: './expiring-token.component.html',
    styleUrls: ['./expiring-token.component.scss'],
    standalone: false
})
export class ExpiringTokenComponent implements OnInit {
    constructor() {
        /* Constructor */
    }

    ngOnInit(): void {
        setInterval(() => this.playSeconds(), 1000);
    }

    playSeconds() {
        const secondsUl = document.getElementsByClassName('secondPlay').item(0);
        const activeLi = Array.from(secondsUl.children).find(e => e.classList.contains('active'));

        if (activeLi === secondsUl.lastChild) {
            // Animation cycle complete, restart
        } else {
            Array.from(secondsUl.children)[0].classList.remove('before');
        }
    }
}
